import { useEffect, useState } from 'react';

import { pageImage, type PageImage } from './pdf-pages';

export type PageImageState =
  { status: 'loading' } | { status: 'ready'; image: PageImage } | { status: 'failed' };

/** A page of the source PDF as an image, from the session cache when it is warm. */
export function usePageImage(url: string, index: number): PageImageState {
  const key = `${url}#${index}`;
  const [loaded, setLoaded] = useState<{ key: string; state: PageImageState } | null>(null);

  useEffect(() => {
    let cancelled = false;
    pageImage(url, index).then(
      (image) => !cancelled && setLoaded({ key, state: { status: 'ready', image } }),
      () => !cancelled && setLoaded({ key, state: { status: 'failed' } }),
    );
    return () => {
      cancelled = true;
    };
  }, [url, index, key]);

  return loaded && loaded.key === key ? loaded.state : { status: 'loading' };
}
